import React, { useState } from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Checkbox, Grid, Modal } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';
import {
  BasicTable,
  Button,
  RadioButton,
  TextField,
  TypableDropdown,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import { commonDropDownProps } from '../../atoms/ReportsCohortItem';
import { Columns } from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/BasicTable';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import AutocompleteWithCheckBoxes from '../../atoms/Autocomplete';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { getInfoIcon } from '../../../core-utils/helper-utils/infoIconHelper';
import { scrollBarStyles } from '../../../core-utils/messages/CommonConstants';
import { useStores } from '../../../stores';
import { toJS } from 'mobx';
import { getAllEmployerGroups } from '../../../core-utils/formatters/UserManagementPageFormatter';
import { getTextWithToolTip } from '../../../core-utils/helper-utils/riskPatientDetailsHelper';

export const cellStyles4 = {
  color: patientAccessTheme.palette.text.mediumemphasis,
  fontSize: '14px',
  fontWeight: 400,
};

const riskManagementColumns: Columns[] = [
  {
    name: 'Yes/No',
    align: 'center',
    cellStyles: cellStyles4,
    width: '30px',
  },
  {
    name: 'Platform',
    align: 'left',
    cellStyles: cellStyles4,
    width: '200px',
  },
  {
    name: 'Member Lives',
    align: 'left',
    cellStyles: cellStyles4,
    width: '130px',
  },
  {
    name: 'Features',
    align: 'left',
    cellStyles: cellStyles4,
    width: '400px',
  },
];

const complianceColumns: Columns[] = [
  {
    name: 'Yes/No',
    align: 'center',
    cellStyles: cellStyles4,
    width: '30px',
  },
  {
    name: 'Platform',
    align: 'left',
    cellStyles: cellStyles4,
    width: '200px',
  },
  {
    name: 'Doc Units',
    align: 'left',
    cellStyles: cellStyles4,
    width: '130px',
  },
  {
    name: 'Features',
    align: 'left',
    cellStyles: cellStyles4,
    width: '350px',
  },
];

const careNavigationColumns: Columns[] = [
  {
    name: 'Yes/No',
    align: 'center',
    cellStyles: cellStyles4,
    width: '30px',
  },
  {
    name: 'Platform',
    align: 'left',
    cellStyles: cellStyles4,
    width: '200px',
  },
  {
    name: 'Cases/Month',
    align: 'left',
    cellStyles: cellStyles4,
    width: '130px',
  },
  {
    name: 'Features',
    align: 'left',
    cellStyles: cellStyles4,
    width: '350px',
  },
];

export interface NewUserModalProps {
  open: boolean;
  isEdit: boolean;
  // isAdmin: boolean;
  isSaveButtonDisabled: boolean;
  handleClose: () => void;
  handleSave: () => void;
  userDataState: [any, React.Dispatch<React.SetStateAction<any>>];
  employerGroupState: [any[], React.Dispatch<React.SetStateAction<any[]>>];
  isAdminState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
}

export interface DataErrorProps {
  firstName?: boolean;
  lastName?: boolean;
  emailID?: boolean;
  organizationName?: boolean;
  totalGroups?: boolean;
}

const NewUserModal: React.FC<NewUserModalProps> = ({
  open,
  isEdit,
  isSaveButtonDisabled,
  handleClose,
  handleSave,
  userDataState,
  employerGroupState,
  isAdminState,
}) => {
  const groupsTableColumns: any[] = [
    {
      name: 'Group Name',
      align: 'left',
      cellStyles: cellStyles4,
      width: '120px',
    },
    {
      name: 'Claims AIQ',
      align: 'center',
      cellStyles: cellStyles4,
      width: '240px',
      colSpan: 2,
    },
    {
      name: 'Contracts AIQ',
      align: 'center',
      cellStyles: cellStyles4,
      width: '240px',
      colSpan: 2,
    },
    {
      name: 'Care Navigation',
      align: 'center',
      cellStyles: cellStyles4,
      width: '240px',
      colSpan: 2,
    },
    {
      name: (
        <div>
          {getInfoIcon(
            'Select a group with radio button and then click any of the below action.',
            () => {},
            {
              display: 'flex',
              alignItems: 'center',
            },
          )}
        </div>
      ),
      align: 'center',
      cellStyles: cellStyles4,
      width: '20px',
    },
  ];

  const [assignData, setAssignData] = userDataState;
  const [isAdmin, setIsAdmin] = isAdminState;
  const [groupsTableRows, setGroupsTableRows] = employerGroupState;

  const useStyles = makeStyles()({
    modal: {
      width: isAdmin ? '1180px' : '728px',
      height: '620px',
      // height: isAdmin ? '620px' : '520px',
      background: patientAccessTheme.palette.status.white,
      borderRadius: '8px',
      padding: '24px 24px 24px 24px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      flexDirection: 'column',
    },
    inputFieldsGrid: {
      width: 'full',
      marginTop: '20px',
      background: '#FBFBFE',
      padding: isAdmin ? '24px 80px 14px 80px' : '24px 24px 14px 24px',
      borderRadius: '8px',
      overflow: 'auto',
      ...(isAdmin && {
        height: '400px',
        ...scrollBarStyles,
      }),
    },
    selectFields: {
      display: 'grid',
      gridTemplateColumns: isAdmin ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)',
      gap: '20px 20px',
      marginBottom: isAdmin ? '10px' : '0px',
    },
    platforms: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
    },
    cancelButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border: '1px solid ' + patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
    saveButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border:
        '1px solid ' + isSaveButtonDisabled
          ? patientAccessTheme.palette.grey[500]
          : patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
    checkbox: {
      '&.MuiCheckbox-root': {
        padding: '0px',
      },

      '&:hover': {
        backgroundColor: 'transparent !important',
      },
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
      },
    },
    buttons: {
      display: 'flex',
      flexDirection: 'row',
      margin: '20px 0px',
      justifyContent: 'end',
    },
    arrowback: {
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: '20px',
    },
  });
  const { classes } = useStyles();

  const constants = componentConstants.MOLECULES.CREATE_NEW_USER;

  const loginStore = useStores().loginPageStore;
  const userDetailsStore = useStores().userDetailsStore;
  const employerGroupStore = useStores().employerGroupStore;

  const allEmployerGroups = getAllEmployerGroups(
    employerGroupStore.allEmployerGroupsData,
    loginStore.employerGroups,
    loginStore.isAdmin,
  );

  const [rowIndex, setRowIndex] = useState<number | undefined>(undefined);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [dataInvalid, setDataInvalid] = useState<DataErrorProps>();

  const getMediumText = (text: string) => {
    return (
      <Typography
        fontSize="14px"
        lineHeight="24px"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
      >
        {text}
      </Typography>
    );
  };

  const getGroupsRows = () => {
    const groupsTableData: any = [
      [
        '',
        'Yes/No',
        'Features',
        'Yes/No',
        'Features',
        getMediumText('Yes/No'),
        getMediumText('Features'),
        '',
      ],
    ];

    groupsTableRows?.map((item: any, index: number) => {
      groupsTableData.push([
        <TypableDropdown
          dropDownOptions={allEmployerGroups?.map((item) => item.name)}
          dropDownValues={allEmployerGroups?.map((item) => item.eg_nid)}
          placeholder={'Select'}
          value={item.employerName}
          handleChange={(event: any) => {
            handleGroupDetailsChange(index, event.target.value, 'egNid');
            const name: string =
              allEmployerGroups.find(
                (item) => item.eg_nid === event.target.value,
              )?.name || '';
            handleGroupDetailsChange(index, name, 'employerName');
          }}
          handleInputChange={() => {}}
          disabled={false}
          textFieldPlaceholder="Search group name here (or) select from below"
          height="36px"
          width="120px"
          searchable={true}
          excludeValues={groupsTableRows.map((item) => item.egNid)}
        />,
        <Checkbox
          className={classes.checkbox}
          color="primary"
          onChange={() =>
            handleGroupDetailsChange(
              index,
              !item.riskManagement,
              'riskManagement',
            )
          }
          checked={item.riskManagement}
          disabled={!assignData.riskManagement}
          disableRipple={true}
          icon={
            <CheckBoxOutlineBlankOutlinedIcon
              style={{
                color: patientAccessTheme.palette.checkbox?.border1,
              }}
            />
          }
        />,
        <AutocompleteWithCheckBoxes
          width="170px"
          options={assignData.riskManagementScreens}
          disabled={!assignData.riskManagement}
          defaultValue={item.riskManagementScreens}
          handleChange={(event: any, value: any) =>
            handleGroupDetailsChange(index, value, 'riskManagementScreens')
          }
          placeholder={constants.SELECTFEATURE}
        />,
        <Checkbox
          className={classes.checkbox}
          color="primary"
          onChange={() =>
            handleGroupDetailsChange(
              index,
              !item.complianceAssurance,
              'complianceAssurance',
            )
          }
          checked={item.complianceAssurance}
          disabled={!assignData.complianceAssurance}
          disableRipple={true}
          icon={
            <CheckBoxOutlineBlankOutlinedIcon
              style={{
                color: patientAccessTheme.palette.checkbox?.border1,
              }}
            />
          }
        />,
        <AutocompleteWithCheckBoxes
          width="170px"
          options={assignData.complianceAssuranceScreens}
          defaultValue={item.complianceAssuranceScreens}
          disabled={!assignData.complianceAssurance}
          handleChange={(event: any, value: any) =>
            handleGroupDetailsChange(index, value, 'complianceAssuranceScreens')
          }
          placeholder={constants.SELECTFEATURE}
        />,
        <Checkbox
          className={classes.checkbox}
          color="primary"
          onChange={() =>
            handleGroupDetailsChange(
              index,
              !item.careNavigation,
              'careNavigation',
            )
          }
          checked={item.careNavigation}
          disabled={!assignData.careNavigation}
          disableRipple={true}
          icon={
            <CheckBoxOutlineBlankOutlinedIcon
              style={{
                color: patientAccessTheme.palette.checkbox?.border1,
              }}
            />
          }
        />,
        <AutocompleteWithCheckBoxes
          width="170px"
          options={assignData.careNavigationScreens}
          defaultValue={item.careNavigationScreens}
          disabled={!assignData.careNavigation}
          handleChange={(event: any, value: any) =>
            handleGroupDetailsChange(index, value, 'careNavigationScreens')
          }
          placeholder={constants.SELECTFEATURE}
        />,
        <RadioButton
          color={patientAccessTheme.palette.primary[400]}
          checked={item.checked || false}
          handleChange={() => handleRowSelect(index)}
        />,
      ]);
    });

    return groupsTableData;
  };

  const handleRowSelect = (index: number) => {
    const localGroupRows: any = groupsTableRows.map((item) => ({
      ...item,
      checked: false,
    }));
    localGroupRows[index].checked = !localGroupRows[index].checked;
    setGroupsTableRows(localGroupRows);
    setRowIndex(localGroupRows[index].checked ? index : undefined);
  };

  const handleRowDelete = () => {
    if (rowIndex !== undefined) {
      const updatedRows = groupsTableRows.filter(
        (_, index) => index !== rowIndex,
      );
      setGroupsTableRows(updatedRows);
      setAssignData((prev: any) => ({
        ...prev,
        employerGroups: updatedRows,
      }));
      setRowIndex(undefined);
    }
  };

  const applyToAll = () => {
    if (rowIndex !== undefined) {
      const localGroupRows: any = groupsTableRows.map((item) => ({
        ...item,
        ...groupsTableRows[rowIndex],
        egNid: item.egNid,
        employerName: item.employerName,
        checked: false,
      }));
      setGroupsTableRows(localGroupRows);
      setAssignData((prev: any) => ({
        ...prev,
        employerGroups: localGroupRows,
      }));
      setRowIndex(undefined);
    }
  };

  const riskManagementData = [
    [
      <Checkbox
        className={classes.checkbox}
        color="primary"
        onChange={() =>
          handleChange(!assignData.riskManagement, 'riskManagement')
        }
        checked={assignData.riskManagement}
        disableRipple={true}
        disabled={loginStore.isAdmin ? !userDetailsStore.riskManagement : false}
        icon={
          <CheckBoxOutlineBlankOutlinedIcon
            style={{
              color: patientAccessTheme.palette.checkbox?.border1,
            }}
          />
        }
      />,
      <Typography
        fontSize="14px"
        lineHeight="24px"
        fontType="normal"
        textColor={patientAccessTheme.palette.text.highemphasis}
      >
        {constants.RISK_MANAGEMENT}
      </Typography>,
      <TextField
        type="number"
        value={assignData.riskManagementQuota}
        error={false}
        disabled={!assignData.riskManagement}
        placeholder={constants.PLACEHOLDER_RISK}
        height="36px"
        width="201px"
        inputPropsStyle={{
          padding: '16px',
        }}
        onChange={(e: any) =>
          handleChange(e.target.value, 'riskManagementQuota')
        }
      />,
      <AutocompleteWithCheckBoxes
        width="380px"
        options={
          loginStore.isAdmin
            ? toJS(userDetailsStore.allScreens)?.riskManagement?.filter((obj) =>
                (
                  toJS(loginStore.userResponse)?.riskManagementScreens || []
                ).includes(obj.value),
              )
            : toJS(userDetailsStore.allScreens)?.riskManagement || []
        }
        disabled={!assignData.riskManagement}
        defaultValue={assignData.riskManagementScreens}
        handleChange={(event: any, value: any) =>
          handleChange(value, 'riskManagementScreens')
        }
        placeholder={constants.SELECTFEATURE}
      />,
    ],
  ];

  const complianceData = [
    [
      <Checkbox
        className={classes.checkbox}
        color="primary"
        onChange={() =>
          handleChange(!assignData.complianceAssurance, 'complianceAssurance')
        }
        checked={assignData.complianceAssurance}
        disableRipple={true}
        disabled={
          loginStore.isAdmin ? !userDetailsStore.complianceAssurance : false
        }
        icon={
          <CheckBoxOutlineBlankOutlinedIcon
            style={{
              color: patientAccessTheme.palette.checkbox?.border1,
            }}
          />
        }
      />,
      <Typography
        fontSize="14px"
        lineHeight="24px"
        fontType="normal"
        textColor={patientAccessTheme.palette.text.highemphasis}
      >
        {constants.COMPLIANCE}
      </Typography>,
      <TextField
        type="number"
        value={assignData.complianceAssuranceQuota}
        disabled={!assignData.complianceAssurance}
        error={false}
        placeholder={constants.PLACEHOLDER_DOC}
        height="36px"
        width="201px"
        inputPropsStyle={{
          padding: '16px',
        }}
        onChange={(e: any) =>
          handleChange(e.target.value, 'complianceAssuranceQuota')
        }
      />,
      <AutocompleteWithCheckBoxes
        width="380px"
        options={
          loginStore.isAdmin
            ? toJS(
                userDetailsStore.allScreens,
              )?.complianceAssurance?.filter((obj) =>
                (
                  toJS(loginStore.userResponse)?.complianceAssuranceScreens ||
                  []
                ).includes(obj.value),
              )
            : toJS(userDetailsStore.allScreens)?.complianceAssurance || []
        }
        disabled={!assignData.complianceAssurance}
        defaultValue={assignData.complianceAssuranceScreens}
        handleChange={(event: any, value: any) =>
          handleChange(value, 'complianceAssuranceScreens')
        }
        placeholder={constants.SELECTFEATURE}
      />,
    ],
  ];

  const careNavigationData = [
    [
      <Checkbox
        className={classes.checkbox}
        color="primary"
        onChange={() =>
          handleChange(!assignData.careNavigation, 'careNavigation')
        }
        checked={assignData.careNavigation}
        disableRipple={true}
        disabled={loginStore.isAdmin ? !userDetailsStore.careNavigation : false}
        icon={
          <CheckBoxOutlineBlankOutlinedIcon
            style={{
              color: patientAccessTheme.palette.checkbox?.border1,
            }}
          />
        }
      />,
      <Typography
        fontSize="14px"
        lineHeight="24px"
        fontType="normal"
        textColor={patientAccessTheme.palette.text.highemphasis}
      >
        {constants.CARE_NAVIGATION}
      </Typography>,
      <TextField
        type="number"
        value={assignData.careNavigationQuota}
        disabled={!assignData.careNavigation}
        error={false}
        placeholder={constants.PLACEHOLDER_CASES}
        height="36px"
        width="201px"
        inputPropsStyle={{
          padding: '16px',
        }}
        onChange={(e: any) =>
          handleChange(e.target.value, 'careNavigationQuota')
        }
      />,
      <AutocompleteWithCheckBoxes
        width="380px"
        options={
          loginStore.isAdmin
            ? toJS(userDetailsStore.allScreens)?.careNavigation?.filter((obj) =>
                (
                  toJS(loginStore.userResponse)?.careNavigationScreens || []
                ).includes(obj.value),
              )
            : toJS(userDetailsStore.allScreens)?.careNavigation || []
        }
        disabled={!assignData.careNavigation}
        defaultValue={assignData.careNavigationScreens}
        handleChange={(event: any, value: any) =>
          handleChange(value, 'careNavigationScreens')
        }
        placeholder={constants.SELECTFEATURE}
      />,
    ],
  ];

  const handleNext = () => {
    if (
      groupsTableRows &&
      Number(assignData.totalGroups) < groupsTableRows.length
    ) {
      const localGroupRows: any = groupsTableRows.slice(
        0,
        Number(assignData.totalGroups),
      );
      setGroupsTableRows(localGroupRows);
      setAssignData((prev: any) => ({
        ...prev,
        employerGroups: localGroupRows,
      }));
    }
    setSelectedIndex(1);
  };

  const addGroup = () => {
    setGroupsTableRows((prev) => [
      ...prev,
      {
        employerName: '',
        egNid: '',
        riskManagement: false,
        riskManagementScreens: [],
        complianceAssurance: false,
        complianceAssuranceScreens: [],
        careNavigation: false,
        careNavigationScreens: [],
        checked: false,
      },
    ]);
  };

  const validateData = (name: string, value?: any) => {
    switch (name) {
      case 'firstName':
      case 'lastName':
      case 'organization_name':
        return value?.match(
          /^[a-zA-Z]+([!@#$%^&*()_+-=\[\];\',.\/<>?:" {}|0-9a-zA-Z]*[!@#$%^&*()_+-=\[\];\',.\/<>?:"{}|0-9a-zA-Z]+)$/,
        );
      case 'emailID':
        return value?.match(
          '^[a-zA-Z0-9_+&*-]+(?:\\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,7}$',
        );
      case 'totalGroups':
        return Number(value) >= 1;
      default:
        return true;
    }
  };

  const handleChange = (value: any, fieldName: string) => {
    const error = !validateData(fieldName, value);
    setAssignData((prevState: any) => ({
      ...prevState,
      [fieldName]: value,
    }));
    setDataInvalid((prevState: any) => ({
      ...prevState,
      [fieldName]: error,
    }));
  };

  const handleGroupDetailsChange = (
    index: number,
    value: any,
    fieldName: string,
  ) => {
    const localGroupRows: any = groupsTableRows;
    localGroupRows[index][fieldName] = value;
    setGroupsTableRows(localGroupRows);
    setAssignData((prev: any) => ({
      ...prev,
      employerGroups: localGroupRows,
    }));
  };

  const getRoleValues = () => {
    if (loginStore.isAdmin) {
      return ['Admin', 'User'];
    } else {
      return ['Super Admin', 'Admin', 'User'];
    }
  };

  const getUserRoles = () => {
    return constants.USER_ROLES.map((item) => getTextWithToolTip(item, 35));
  };

  const saveButtonEnabled = () => {
    if (
      assignData.firstName === '' ||
      dataInvalid?.firstName ||
      assignData.lastName === '' ||
      dataInvalid?.lastName ||
      assignData.emailID === '' ||
      dataInvalid?.emailID ||
      assignData.user_role === '' ||
      assignData.organization_name === '' ||
      dataInvalid?.organizationName ||
      assignData.role === '' ||
      (assignData.role !== 'Super Admin' &&
        (assignData.totalGroups === '' ||
          Number(assignData.totalGroups) < 1)) ||
      (assignData.riskManagement && assignData.riskManagementQuota === '') ||
      (assignData.complianceAssurance &&
        assignData.complianceAssuranceQuota === '') ||
      (assignData.careNavigation && assignData.careNavigationQuota === '') ||
      dataInvalid?.totalGroups
    ) {
      return true;
    }
    return false;
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Grid container className={classes.modal}>
          {selectedIndex === 0 ? (
            <>
              <Grid>
                <Typography
                  fontSize="18px"
                  lineHeight="26px"
                  fontType="semibold"
                  textColor={patientAccessTheme.palette.text.highemphasis}
                  margin="4px 0px 0px 0px"
                >
                  {isEdit ? constants.UPDATE_TITLE : constants.TITLE}
                </Typography>
                <Typography
                  fontSize="14px"
                  lineHeight="24px"
                  fontType="normal"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  margin="4px 0px 5px 0px"
                >
                  {isEdit ? constants.UPDATE_SUBTITLE : constants.SUBTITLE}
                </Typography>
              </Grid>

              <Grid container className={classes.inputFieldsGrid}>
                <Grid className={classes.selectFields}>
                  <ReportCreateNewLabelField
                    label={constants.FIRSTNAME}
                    component={
                      <TextField
                        value={assignData.firstName}
                        error={dataInvalid?.firstName}
                        placeholder={constants.PLACEHOLDER_FIRST_NAME}
                        height="36px"
                        width="301px"
                        inputPropsStyle={{
                          padding: '16px',
                        }}
                        onChange={(e: any) =>
                          handleChange(e.target.value, 'firstName')
                        }
                      />
                    }
                  />
                  <ReportCreateNewLabelField
                    label={constants.LASTNAME}
                    component={
                      <TextField
                        value={assignData.lastName}
                        error={dataInvalid?.lastName}
                        placeholder={constants.PLACEHOLDER_LAST_NAME}
                        height="36px"
                        width="301px"
                        inputPropsStyle={{
                          padding: '16px',
                        }}
                        onChange={(e: any) =>
                          handleChange(e.target.value, 'lastName')
                        }
                      />
                    }
                  />
                  <ReportCreateNewLabelField
                    label={constants.EMAILID}
                    component={
                      <TextField
                        value={assignData.emailID}
                        error={dataInvalid?.emailID}
                        placeholder={constants.PLACEHOLDER_EMAIL_ID}
                        disabled={isEdit}
                        height="36px"
                        width="301px"
                        inputPropsStyle={{
                          padding: '16px',
                        }}
                        onChange={(e: any) =>
                          handleChange(e.target.value, 'emailID')
                        }
                      />
                    }
                  />
                  <ReportCreateNewLabelField
                    label={constants.ACCESS_LEVEL}
                    component={
                      <Dropdown
                        label={'Select'}
                        dropDownOptions={getRoleValues()}
                        dropDownValues={getRoleValues()}
                        value={assignData.role}
                        setValue={null}
                        handleChange={(e) => {
                          handleChange(e.target.value, 'role');
                          if (e.target.value !== 'Super Admin') {
                            setIsAdmin(true);
                          } else {
                            setIsAdmin(false);
                          }
                        }}
                        selectStyles={{
                          ...commonDropDownProps.selectStyles,
                          width: '301px',
                        }}
                        labelTop="10px"
                      />
                    }
                  />
                  <ReportCreateNewLabelField
                    label={constants.ROLE}
                    component={
                      <Dropdown
                        label={'Select'}
                        dropDownOptions={getUserRoles()}
                        dropDownValues={constants.USER_ROLES}
                        value={assignData.user_role}
                        setValue={null}
                        handleChange={(e) => {
                          handleChange(e.target.value, 'user_role');
                        }}
                        selectStyles={{
                          ...commonDropDownProps.selectStyles,
                          width: '301px',
                        }}
                        labelTop="10px"
                      />
                    }
                  />
                  <ReportCreateNewLabelField
                    label={constants.ORGANIZATION_NAME}
                    component={
                      <TextField
                        value={assignData.organization_name}
                        error={dataInvalid?.organizationName}
                        placeholder={constants.PLACEHOLDER_ORGANIZATION_NAME}
                        height="36px"
                        width="301px"
                        inputPropsStyle={{
                          padding: '16px',
                        }}
                        onChange={(e: any) =>
                          handleChange(e.target.value, 'organization_name')
                        }
                      />
                    }
                  />
                  {isAdmin && (
                    <ReportCreateNewLabelField
                      label={constants.GROUPNO}
                      component={
                        <TextField
                          type="number"
                          value={assignData.totalGroups}
                          error={false}
                          placeholder={constants.PLACEHOLDER_GROUP}
                          height="36px"
                          width="301px"
                          inputPropsStyle={{
                            padding: '16px',
                          }}
                          onChange={(e: any) => {
                            handleChange(e.target.value, 'totalGroups');
                          }}
                        />
                      }
                    />
                  )}
                  <ReportCreateNewLabelField
                    label={constants.EXTRACTION_METHOD}
                    component={
                      <Dropdown
                        label={constants.PLACEHOLDER_EXTRACTION_METHOD}
                        dropDownOptions={constants.EXTRACTION_METHODS}
                        dropDownValues={constants.EXTRACTION_METHODS}
                        value={assignData.extractionMethod}
                        setValue={null}
                        handleChange={(e) => {
                          handleChange(e.target.value, 'extractionMethod');
                        }}
                        selectStyles={{
                          ...commonDropDownProps.selectStyles,
                          width: '301px',
                        }}
                        labelTop="10px"
                      />
                    }
                  />
                </Grid>
                {isAdmin && (
                  <ReportCreateNewLabelField
                    label={constants.SELECTPLATFORM}
                    component={
                      <Grid className={classes.platforms}>
                        <BasicTable
                          width={'940px'}
                          displayType={'box'}
                          columns={riskManagementColumns}
                          rowsData={riskManagementData}
                          headerTextColor={
                            patientAccessTheme.palette.status.white
                          }
                          headerColor={patientAccessTheme.palette.grey[700]}
                          borderRadius="4px"
                        />
                        <BasicTable
                          width={'940px'}
                          displayType={'box'}
                          columns={complianceColumns}
                          rowsData={complianceData}
                          headerTextColor={
                            patientAccessTheme.palette.status.white
                          }
                          headerColor={patientAccessTheme.palette.grey[700]}
                          borderRadius="4px"
                        />
                        <BasicTable
                          width={'940px'}
                          displayType={'box'}
                          columns={careNavigationColumns}
                          rowsData={careNavigationData}
                          headerTextColor={
                            patientAccessTheme.palette.status.white
                          }
                          headerColor={patientAccessTheme.palette.grey[700]}
                          borderRadius="4px"
                        />
                      </Grid>
                    }
                  />
                )}
              </Grid>

              <Grid className={classes.buttons}>
                <Grid style={{ marginRight: '12px' }}>
                  <Button
                    label={constants.CANCEL}
                    variant="outlined"
                    className={classes.cancelButton}
                    onClick={handleClose}
                  />
                </Grid>
                <Grid>
                  <Button
                    label={isAdmin ? constants.NEXT : constants.SUBMIT}
                    variant="contained"
                    className={classes.saveButton}
                    disabled={isSaveButtonDisabled || saveButtonEnabled()}
                    onClick={isAdmin ? handleNext : handleSave}
                  />
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              <Grid className={classes.header}>
                <Grid className={classes.arrowback}>
                  <ArrowBack
                    onClick={() => setSelectedIndex(0)}
                    style={{
                      color: patientAccessTheme.palette.checkbox?.border1,
                    }}
                  />
                  <Grid>
                    <Typography
                      fontSize="18px"
                      lineHeight="26px"
                      fontType="semibold"
                      textColor={patientAccessTheme.palette.text.highemphasis}
                      margin="4px 0px 0px 0px"
                    >
                      {isEdit ? constants.UPDATE_TITLE : constants.TITLE}
                    </Typography>
                    <Typography
                      fontSize="14px"
                      lineHeight="24px"
                      fontType="normal"
                      textColor={patientAccessTheme.palette.text.mediumemphasis}
                      margin="4px 0px 5px 0px"
                    >
                      {isEdit ? constants.UPDATE_SUBTITLE : constants.SUBTITLE}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  style={{
                    display: 'flex',
                    alignItems: 'end',
                  }}
                >
                  <Button
                    label={constants.ADD_GROUP}
                    variant="contained"
                    className={classes.saveButton}
                    disabled={
                      Number(assignData.totalGroups) === groupsTableRows?.length
                    }
                    onClick={addGroup}
                  />
                </Grid>
              </Grid>

              <BasicTable
                width="1130px"
                displayType="box"
                columns={groupsTableColumns}
                rowsData={getGroupsRows()}
                headerTextColor={patientAccessTheme.palette.status.white}
                headerColor={patientAccessTheme.palette.grey[700]}
                borderRadius="4px"
                rootStyles={{
                  overflow: 'auto',
                  ...(isAdmin && {
                    height: '400px',
                    ...scrollBarStyles,
                  }),
                }}
              />

              <Grid
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  margin: '20px 0px',
                  justifyContent: 'end',
                }}
              >
                <Grid style={{ marginRight: '12px' }}>
                  <Button
                    label={constants.REMOVE}
                    variant="outlined"
                    disabled={rowIndex === undefined}
                    className={classes.cancelButton}
                    onClick={handleRowDelete}
                  />
                </Grid>
                <Grid style={{ marginRight: '12px' }}>
                  <Button
                    label={constants.APPLYALL}
                    variant="outlined"
                    disabled={rowIndex === undefined}
                    className={classes.cancelButton}
                    onClick={applyToAll}
                  />
                </Grid>
                <Grid style={{ marginRight: '12px' }}>
                  <Button
                    label={constants.CANCEL}
                    variant="outlined"
                    className={classes.cancelButton}
                    onClick={handleClose}
                  />
                </Grid>
                <Grid>
                  <Button
                    label={constants.SUBMIT}
                    variant="contained"
                    className={classes.saveButton}
                    disabled={isSaveButtonDisabled}
                    onClick={handleSave}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Modal>
    </>
  );
};

export default NewUserModal;
